import { AbstractControl, FormGroup } from '@angular/forms';
import { Message } from '../../../../osp-ui/contract/message.contract';
import { AlarmSettingsFieldData } from '../../contract/alarm-settings-field-data.contract';
import { AlarmRuleControl } from '../../enums/alarm-rule-control.enum';
import { AlarmSettingsFormControls } from './contract/alarm-settings-form-controls.contract';

export class AlarmSettingsBase {
  public readonly controlNames = AlarmRuleControl;

  public settingsForm!: FormGroup<AlarmSettingsFormControls>;

  protected alarmSettingsFieldData: AlarmSettingsFieldData = {};

  public get limitControl(): AbstractControl | null {
    return this.settingsForm.get(this.controlNames.SETTINGS_LIMIT);
  }

  public get intervalControl(): AbstractControl | null {
    return this.settingsForm.get(this.controlNames.SETTINGS_INTERVAL);
  }

  public get geofenceControl(): AbstractControl | null {
    return this.settingsForm.get(this.controlNames.SETTINGS_GLOBAL_GEOFENCE);
  }

  public get geofenceTriggerControl(): AbstractControl | null {
    return this.settingsForm.get(this.controlNames.SETTINGS_GEOFENCE_TRIGGER);
  }

  public get hourControl(): AbstractControl | null {
    return this.settingsForm.get(this.controlNames.SETTINGS_TIMEFENCING_HOURS);
  }

  public get distanceControl(): AbstractControl | null {
    return this.settingsForm.get(this.controlNames.SETTINGS_TIMEFENCING_DISTANCE);
  }

  public get weekDayControl(): AbstractControl | null {
    return this.settingsForm.get(this.controlNames.SETTINGS_TIMEFENCING_WEEK_DAY);
  }

  public getFieldLabel(controlName: AlarmRuleControl): string {
    return this.alarmSettingsFieldData?.[controlName]?.label || '';
  }

  public getFieldExplanation(controlName: AlarmRuleControl): Message {
    return { detail: this.alarmSettingsFieldData[controlName]?.explanation || '', severity: 'info' };
  }

  public getFieldTooltipText(controlName: AlarmRuleControl): string {
    return this.alarmSettingsFieldData[controlName]?.explanation || '';
  }
}
